<div class="row">
  <span [ngClass]="getIcon()"></span>
</div>
